module.exports = __webpack_public_path__ + "img/pexels-george-milton.c042969f.png";